// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".request-access-form[data-v-28cd845b] .el-checkbox{display:flex;white-space:normal}.request-access-form[data-v-28cd845b] .el-checkbox>*{min-width:0}.request-access-form[data-v-28cd845b] .el-checkbox__input{margin-top:.2em}.request-access-form .agreement[data-v-28cd845b] .el-checkbox__label:before{color:#e5285d;content:\"*\";margin-right:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
